import { responsiveFont } from "./responsiveFont"; // update path as needed

const GlobalStyles = {
  GlobalBg: {
    // Original: "#add0b3"
    backgroundColor: "#add0b3",
    // Adding gradient colors for the background
    gradientColors: ["#e0ffe2", "#add0b3", "#8aa68f"], // Lighter green to your original, then a slightly darker shade
    headerColor: "#2f5232",
    headerBorder: "#254128",
  },
  GlobalFont: {
    fontFamily: "LatoBlack",
  },
  inpColor: {
    colors: {
      background: "#f2fff7",
      placeholder: "#3a4918",
      selection: "#3f5a49",
    },
  },
  fontSize: {
    xsss: responsiveFont(11),
    xss: responsiveFont(12),
    xs: responsiveFont(14),
    sm: responsiveFont(16),
    md: responsiveFont(18),
    lg: responsiveFont(20),
    xl: responsiveFont(22),
    xxl: responsiveFont(24),
    xxxl: responsiveFont(26),
    topTitle: responsiveFont(15),
    btn: responsiveFont(18),
  },
  inpFont: {
    fontFamily: "LatoRegular",
  },
  btnColor: {
    // Original: "#3f5a49"
    backgroundColor: "#3f5a49",
    // Adding gradient colors for buttons
    gradientColors: ["#5e836b", "#3f5a49", "#254128"], // Lighter shade, original, then darker for depth
  },
  titleTxtOffset: {
    textShadowColor: "rgba(0, 0, 0, 0.2)", // Softer shadow for title
    textShadowOffset: { width: 1, height: 1 },
    textShadowRadius: 1,
  },
  btntxtoffset: {
    textShadowColor: "rgba(0, 0, 0, 0.4)", // Slightly softer shadow for button text
    textShadowOffset: { width: 1, height: 1 },
    textShadowRadius: 1,
  },
  btnBgShadow: {
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 }, // More vertical shadow
    shadowOpacity: 0.25, // Softer opacity
    shadowRadius: 6, // Larger blur
    elevation: 8, // Increased elevation for Android
    borderColor: "rgba(255, 255, 255, 0.2)", // Subtle light border for contrast
    borderWidth: 1, // Reduced border width
  },
  //dropdown styles
  dropdown: {
    modalContentContainerStyle: {
      backgroundColor: "#effdee",
    },
    textStyle: {
      fontFamily: "LatoRegular",
      fontSize: 16,
      color: "#333",
    },
    labelStyle: {
      fontFamily: "LatoRegular",
      fontSize: 16,
      color: "#333",
    },
    placeholderStyle: {
      fontFamily: "LatoRegular",
      fontSize: 16,
      color: "#3a4918", // matches inpColor.colors.placeholder
    },
  },
};

export default GlobalStyles;
